/* Moves the campaign tiles into the mobile menu.

   sections/dico-menu-highlights.liquid renders its markup wherever the header
   section group puts it, which is not where it belongs. This moves that one
   element to the end of the mobile menu's <nav> and reveals it.

   ------------------------------------------------------------------
   Why a move rather than rendering it in place

   The mobile menu is snippets/header-mobile.liquid, a snippet. Snippets have no
   settings of their own and cannot read another section's blocks, so
   editor-chosen images cannot reach it directly. Adding blocks to
   sections/header.liquid and threading them down would avoid this script, but
   that file is 25KB of core theme code and rewriting it wholesale to add a block
   type is the operation that has broken this theme before. Moving one element is
   the smaller risk, and header-mobile.liquid stays byte-for-byte the theme's
   original.

   Same approach as assets/dico-size-guide.js, which moves the product panels to
   <body> for a different reason.

   ------------------------------------------------------------------
   The hidden attribute is the anti-flash

   The section renders with hidden set, so it is never painted in the header on
   the way past. It is only revealed once it is inside the menu. If this script
   fails to run the tiles stay hidden rather than appearing in the wrong place -
   which is the right way round for something purely decorative.

   ------------------------------------------------------------------
   Why it keeps watching

   The theme editor re-renders a section into its original position when its
   settings change, which would leave the tiles back outside the menu and hidden.
   shopify:section:load covers that. The MutationObserver covers the header being
   rebuilt for any other reason; it is cheap because place() exits immediately
   once the element is already in the right parent. */
(function () {
    'use strict';

    function place() {
        var tiles = document.querySelector('[data-dico-mh]');
        if (!tiles) { return; }

        var menu = document.querySelector('#mobmenu .mobnav nav');
        if (!menu) { return; }

        if (tiles.parentNode !== menu) {
            menu.appendChild(tiles);
        }

        if (tiles.hasAttribute('hidden')) {
            tiles.removeAttribute('hidden');
        }
    }

    var pending = null;
    function placeSoon() {
        if (pending) { window.clearTimeout(pending); }
        pending = window.setTimeout(function () { pending = null; place(); }, 50);
    }

    function start() {
        place();

        if (window.MutationObserver) {
            var header = document.querySelector('#mobmenu') || document.body;
            new MutationObserver(placeSoon).observe(header, { childList: true, subtree: true });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }

    document.addEventListener('shopify:section:load', placeSoon);
}());